module.exports = __webpack_public_path__ + "static/media/topImage.7322b8a0.jpg";